import React from 'react';
import { Star as StarIcon, StarBorder as StarBorderIcon } from '@mui/icons-material';
import { MAX_FEATURED_PRODUCTS } from '../../utils/featuredProducts';
import './FeaturedProductsPanel.css';

const FeaturedProductsPanel = ({ featuredProducts = [] }) => (
  <section className="featured-products-panel">
    <div className="featured-products-panel__header">
      <h2 className="featured-products-panel__title">Produits mis en avant</h2>
      <p className="featured-products-panel__hint">
        Jusqu&apos;à {MAX_FEATURED_PRODUCTS} produits <strong>actifs</strong> affichés en tête de
        votre boutique et sur votre fiche artisan.
      </p>
    </div>

    {featuredProducts.length > 0 ? (
      <ol className="featured-products-panel__list">
        {featuredProducts.map((product, index) => (
          <li key={product.id} className="featured-products-panel__item">
            <span className="featured-products-panel__rank">{index + 1}</span>
            <StarIcon className="featured-products-panel__star" fontSize="small" />
            <span className="featured-products-panel__name">{product.name}</span>
            <span className="featured-products-panel__reference">{product.reference}</span>
          </li>
        ))}
      </ol>
    ) : (
      <p className="featured-products-panel__empty">
        Aucun produit mis en avant pour le moment. Utilisez l&apos;étoile sur un produit actif
        ci-dessous.
      </p>
    )}
  </section>
);

export default FeaturedProductsPanel;
